import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SortIcon from "@mui/icons-material/Sort";
import PrintIcon from "@mui/icons-material/Print";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import { Tooltip } from "@mui/material";


import {
  partyList,
  deleteParty,
  updateParty,
} from "../../../Services/Services"; // Update with actual path
import AddParty from "./AddParty";
import Popover from "@mui/material/Popover";

const PartyList = () => {
  const [parties, setParties] = useState([]);
  const [editPartyId, setEditPartyId] = useState(null); // Store the partyId instead of index
  const [editPartyData, setEditPartyData] = useState({});
  const [openEditModal, setOpenEditModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [sortAsc, setSortAsc] = useState(true);
  const [editErrors, setEditErrors] = useState({});
  const [openAddModal, setOpenAddModal] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [partyToDelete, setPartyToDelete] = useState(null);

  useEffect(() => {
    const fetchParties = async () => {
      const data = await partyList();
      setParties(data);
    };

    fetchParties();
  }, []);

  const getFilteredSortedParties = () => {
    let filtered = parties.filter(
      (party) =>
        party.name?.toLowerCase().includes(filter.toLowerCase()) ||
        party.address?.toLowerCase().includes(filter.toLowerCase())
    );

    filtered.sort((a, b) => {
      const nameA = a.name?.toLowerCase() || "";
      const nameB = b.name?.toLowerCase() || "";
      return sortAsc ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
    });

    return filtered;
  };

  const handleDelete = async (party_id) => {
    try {
      const response = await deleteParty(party_id); // don't pass any argument if not needed
      setParties(response);
    } catch (error) {
      console.error("Error fetching branch:", error);
    }
  };

  const handleEdit = (partyId) => {
    const partyToEdit = parties.find((party) => party.party_id === partyId);
    setEditPartyData({ ...partyToEdit });
    setEditPartyId(partyId);
    setOpenEditModal(true);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    const updatedErrors = { ...editErrors };

    if (name === "contact_no") {
      newValue = value.replace(/\D/g, "").slice(0, 10);
      if (newValue.length !== 10) {
        updatedErrors.contact_no = "Contact number must be exactly 10 digits.";
      } else {
        delete updatedErrors.contact_no;
      }
    }

    // if (name === 'gst_no') {
    //   newValue = value.toUpperCase().slice(0, 15);
    //   const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    //   if (!gstRegex.test(newValue)) {
    //     updatedErrors.gst_no = 'Invalid GST No format, a valid GST No format is: 22AAAAA0000A1Z5.';
    //   } else {
    //     delete updatedErrors.gst_no;
    //   }
    // }

    // if (name === 'pan_no') {
    //   newValue = value.toUpperCase().slice(0, 10);
    //   const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    //   if (!panRegex.test(newValue)) {
    //     updatedErrors.pan_no = 'Invalid PAN No format, a valid PAN No format is: ABCDE1234F.';
    //   } else {
    //     delete updatedErrors.pan_no;
    //   }
    // }

    setEditPartyData((prev) => ({ ...prev, [name]: newValue }));
    setEditErrors(updatedErrors);
  };

  const validateEditInputs = () => {
    const { contact_no, gst_no, pan_no } = editPartyData;
    const validationErrors = {};

    if (!/^\d{10}$/.test(contact_no)) {
      validationErrors.contact_no = "Contact number must be exactly 10 digits.";
    }

    // if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gst_no)) {
    //   validationErrors.gst_no = 'Invalid GST No format, a valid GST No format is: 22AAAAA0000A1Z5.';
    // }

    // if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan_no)) {
    //   validationErrors.pan_no = 'Invalid PAN No format, a valid PAN No format is: ABCDE1234F.';
    // }

    return validationErrors;
  };

  const handleSaveEdit = async () => {
    const validationErrors = validateEditInputs();
    if (Object.keys(validationErrors).length > 0) {
      setEditErrors(validationErrors);
      return;
    }

    try {
      const response = await updateParty(editPartyId, editPartyData); // don't pass any argument if not needed
      setParties(response);
      setOpenEditModal(false);
    } catch (error) {
      console.error("Error fetching users:", error);
    }

    setEditErrors({});
  };

  const handleCancelEdit = () => {
    setOpenEditModal(false);
    setEditErrors({});
  };

  const handlePrint = () => {
    const printContents = document.getElementById("printable-table").innerHTML;

    const printWindow = window.open("", "", "width=900,height=650");
    printWindow.document.write(`
    <html>
    <head>
      <title>Party List</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 0px 20px;
        }
        header {
          text-align: center;
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 10px;
          color: #333;
        }
        footer {
          position: fixed;
          bottom: 10px;
          width: 100%;
          text-align: center;
          font-size: 12px;
          color: #333;
        }
        table {
          width: 100%;
          border-collapse: collapse;
        }
        th, td {
          border: 1px solid #000;
          padding: 6px;
          text-align: center;
          font-size: 12px;
        }
        th {
          background-color: #ddd;
          color: #000;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        tr:nth-child(even) {
          background-color: #f9f9f9;
        }
        .no-print {
          display: none !important;
        }
      </style>
    </head>
    <body>
      <header>SR ENTERPRICES</header>
      <h4 style="text-align: center;">Party List</h4>
      <div>${printContents}</div>
      <footer>Powered by : YASHVITECH IT SOLUTION PVT LTD</footer>
      <script>
        window.onload = function () {
          window.print();
          window.onafterprint = function () {
            window.close();
          };
        };
      </script>
    </body>
    </html>
  `);
    printWindow.document.close();
    printWindow.focus();
  };

  const handleExportToExcel = () => {
    const exportData = getFilteredSortedParties().map((party, index) => ({
      "S. No.": index + 1,
      "Party ID": party.party_id,
      "Party Name": party.name,
      "Contact No": party.contact_no,
      Address: party.address,
      "GST No": party.gst_no,
      "PAN No": party.pan_no,
    }));

    const headers = Object.keys(exportData[0]);
    const worksheetData = [
      headers,
      ...exportData.map((obj) => Object.values(obj)),
    ];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Auto width
    const columnWidths = headers.map((_, colIdx) => {
      const maxLength = worksheetData.reduce((max, row) => {
        const cell = row[colIdx];
        return Math.max(max, cell ? cell.toString().length : 10);
      }, headers[colIdx].length);
      return { wch: maxLength + 2 };
    });
    worksheet["!cols"] = columnWidths;

    const blackBorder = {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    };

    // Style headers
    headers.forEach((_, colIdx) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIdx });
      const cell = worksheet[cellAddress];
      if (cell) {
        cell.s = {
          fill: { fgColor: { rgb: "FFFF99" } },
          font: { bold: true, color: { rgb: "000000" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: blackBorder,
        };
      }
    });

    // Style data rows
    for (let r = 1; r < worksheetData.length; r++) {
      for (let c = 0; c < headers.length; c++) {
        const cell = worksheet[XLSX.utils.encode_cell({ r, c })];
        if (cell) {
          cell.s = {
            alignment: { horizontal: "center", vertical: "center" },
            border: blackBorder,
          };
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Parties");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "PartyList.xlsx");
  };

  return (
    <Box sx={{ maxHeight: "calc(100vh - 70px)", }}>
      {/* Top Controls */}
      <Box
        sx={{
          // position: "sticky",
          top: 0,
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 2,
          py: 1,
          flexWrap: "wrap",
            
          
        }}
      >
        <TextField
          label="Search by party name or address"
          variant="outlined"
          size="small"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          sx={{ minWidth: 250 , marginTop: -5,}}
        />

        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            border: "1px solid #ccc",
            px: 2,
            py: 1,
            borderRadius: "8px",
            whiteSpace: "nowrap",
            minWidth: 220,
             marginTop: -5,
          }}
        >
          Total Parties: {getFilteredSortedParties().length}
        </Typography>

        <Button
          variant="outlined"
          sx={{  marginTop: -5, }}
          startIcon={<SortIcon />}
          onClick={() => setSortAsc(!sortAsc)}
        >
          Sort by Name ({sortAsc ? "A-Z" : "Z-A"})
        </Button>
        <Button
          variant="contained"
          color="primary"
           sx={{  marginTop: -5, }}
          onClick={() => setOpenAddModal(true)}
        >
          Add New Party
        </Button>
        <Button
          variant="outlined"
          sx={{ minWidth: "40px", padding: 0.8,marginTop: -5, }}
          onClick={handleExportToExcel}
        >
          <FileDownloadIcon fontSize="small" />
        </Button>
        <Button
          variant="outlined"
          sx={{ minWidth: "40px", padding: 0.8,marginTop: -5, }}
          onClick={handlePrint}
        >
          <PrintIcon fontSize="small" />
        </Button>
      </Box>

      {/* Table */}
      {parties.length === 0 ? (
        <Typography>No parties found.</Typography>
      ) : (
        <TableContainer
          id="printable-table"
          sx={{ overflowX: "auto", maxHeight: "75vh" }}
        >
          <Table
            stickyHeader
            size="small"
            sx={{ "& td, & th": { borderBottom: "1px solid #ccc" } }}
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f5f5f5",
                  "& th": {
                    fontWeight: "bold",
                    color: "#333",
                    borderBottom: "1px solid #999",
                    whiteSpace: "nowrap",
                  },
                }}
              >
                <TableCell align="center">S. No.</TableCell>

                <TableCell align="center">Party Name</TableCell>
                <TableCell align="center">Munsiyana</TableCell>
                <TableCell align="center">Contact No</TableCell>
                <TableCell align="center">Alternate No</TableCell>
                <TableCell align="center">Alternate No</TableCell>
                <TableCell align="center">Address</TableCell>
                <TableCell align="center">GST No</TableCell>
                <TableCell align="center" className="last-visible-cell">
                  PAN No
                </TableCell>
                <TableCell align="center" className="no-print">
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getFilteredSortedParties().map((party, index) => (
                <TableRow
                  key={party.partyId}
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff", // alternate row color
                    "& td": {
                      paddingTop: "0px",
                      paddingBottom: "0px",
                      fontSize: "0.8125rem",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: 120,
                      color: (theme) =>
                        theme.palette.mode === "dark" ? "white" : "inherit",
                      backgroundColor: (theme) =>
                        theme.palette.mode === "dark" ? "black" : "inherit",
                    },
                  }}
                >
                  <TableCell align="center">{index + 1}</TableCell>

                  {/* <TableCell align="center">{party.name}</TableCell> */}
                  <TableCell align="center">
                    <Tooltip title={party.name || ""} arrow>
                      <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {party.name}
                      </div>
                    </Tooltip>
                  </TableCell>

                  <TableCell align="center">{party.commission}</TableCell>
                  <TableCell align="center">{party.contact_no} </TableCell>
                  <TableCell align="center">{party.contact_no1} </TableCell>
                  <TableCell align="center">{party.contact_no2} </TableCell>
                  {/* <TableCell align="center">{party.address}</TableCell> */}


                  <TableCell align="center">
                    <Tooltip title={party.address || ""} arrow>
                      <span>{party.address}</span>
                    </Tooltip>
                  </TableCell>

                  <TableCell align="center">{party.gst_no}</TableCell>
                  <TableCell align="center" className="last-visible-cell">
                    {party.pan_no}
                  </TableCell>
                  <TableCell align="center" className="no-print">
                    <IconButton
                      onClick={() => handleEdit(party.party_id)}
                      color="primary"
                      size="small"
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    {/* <IconButton onClick={() => handleDelete(party.party_id)} color="error" size="small">
                      <DeleteIcon fontSize="small" />
                    </IconButton> */}
                    <IconButton
                      onClick={(event) => {
                        setAnchorEl(event.currentTarget);
                        setPartyToDelete(party.party_id);
                      }}
                      color="error"
                      size="small"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Edit Modal */}
      <Dialog open={openEditModal} onClose={handleCancelEdit}>
        <DialogTitle>Edit Party</DialogTitle>
        <DialogContent>
          <TextField
            label="Party Name"
            fullWidth
            margin="normal"
            name="name"
            value={editPartyData.name || ""}
            onChange={handleEditChange}
          />
          <TextField
            fullWidth
            label="Munsiyana"
            name="commission"
            value={editPartyData.commission}
            onChange={handleEditChange}
          />
          <TextField
            label="Contact No"
            fullWidth
            margin="normal"
            name="contact_no"
            value={editPartyData.contact_no || ""}
            onChange={handleEditChange}
            error={!!editErrors.contact_no}
          />
          <TextField
            label="Contact No"
            fullWidth
            margin="normal"
            name="contact_no1"
            value={editPartyData.contact_no1 || ""}
            onChange={handleEditChange}
            error={!!editErrors.contact_no1}
          />
          <TextField
            label="Contact No"
            fullWidth
            margin="normal"
            name="contact_no2"
            value={editPartyData.contact_no2 || ""}
            onChange={handleEditChange}
            error={!!editErrors.contact_no2}
          />
          <TextField
            label="Address"
            fullWidth
            margin="normal"
            name="address"
            value={editPartyData.address || ""}
            onChange={handleEditChange}
          />
          <TextField
            label="GST No"
            fullWidth
            margin="normal"
            name="gst_no"
            value={editPartyData.gst_no || ""}
            onChange={handleEditChange}
            error={!!editErrors.gst_no}
            helperText={editErrors.gst_no || "Format: 22AAAAA0000A1Z5"}
          />
          <TextField
            label="PAN No"
            fullWidth
            margin="normal"
            name="pan_no"
            value={editPartyData.pan_no || ""}
            onChange={handleEditChange}
            error={!!editErrors.pan_no}
            helperText={editErrors.pan_no || "Format: ABCDE1234F"}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelEdit} color="error">
            Cancel
          </Button>
          <Button onClick={handleSaveEdit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Add New Party</DialogTitle>
        <DialogContent dividers>
          <AddParty setParties={setParties} setOpenAddModal={setOpenAddModal} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAddModal(false)} color="error">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setPartyToDelete(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 1 }}>
          <Typography variant="body2">Are you sure ?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                try {
                  await handleDelete(partyToDelete);
                } finally {
                  setAnchorEl(null);
                  setPartyToDelete(null);
                }
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setPartyToDelete(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default PartyList;